import { FC } from 'react';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

/**
 * Wraps a header so it scrolls normally until it reaches the app's fixed header, then pins there and
 * rides along. `tw-top-24` is 96px — the height of `.nc_header` — so the pinned header sits right below
 * it; `tw-z-30` keeps it above the dashboard connectors and badges (z-10/z-20).
 *
 * Sticky keeps the header in the normal flow, so it inherits the width and horizontal position of its
 * centered column and leaves no gap behind when it pins. This replaced a scroll listener that toggled
 * `position: fixed` and re-measured width/left into a placeholder, which was only necessary while a
 * global `overflow-x: hidden` on body made it a scroll container and broke sticky app-wide.
 */
export const StickyHeaderOnScroll: FC<Props> = ({ children }) => (
  <div className="tw-sticky tw-top-24 tw-z-30 tw-w-full">{children}</div>
);
